(function($) {
	'use strict';

	/**
	 * Extract unique control values from data
	 * 
	 * This function processes data to extract unique control values for each
	 * category and control ID. It handles multiple entries in single strings
	 * by splitting on newlines and trimming whitespace.
	 * 
	 * @param {Object} data - The data object containing categories and control IDs
	 * @returns {Object} Object containing unique values organized by category and control ID
	 */
	function extractUniqueControlValues(data) {
		const uniqueValues = {};

		// Iterate over each category in the data
		for (const categoryKey in data) {
			uniqueValues[categoryKey] = {};

			// Iterate over each control ID within the category
			for (const controlId in data[categoryKey]) {
				const controlData = data[categoryKey][controlId];
				const valuesSet = new Set();

				// Iterate over each item in the control array
				controlData.forEach(item => {
					// Split by newline and trim each item to handle multiple entries in a single string
					item.split('\n').forEach(subItem => valuesSet.add(subItem.trim()));
				});

				// Convert the Set to an array and assign to the corresponding control ID
				uniqueValues[categoryKey][controlId] = Array.from(valuesSet);
			}
		}

		return uniqueValues;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { extractUniqueControlValues };
	} else if (typeof window !== 'undefined') {
		window.extractUniqueControlValues = extractUniqueControlValues;
	}

})(jQuery);
